import { render, staticRenderFns } from "./NotDriverMonthlyScoreError.vue?vue&type=template&id=115edc15&"
import script from "./NotDriverMonthlyScoreError.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyScoreError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports